import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import ZuiContentHeader from '@zenbusiness/zui/ContentHeader';
import Grid from '@zenbusiness/zui/Grid';
import Heading from '@zenbusiness/zui/Heading';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ContentHeader = superstyled({
  tag: ZuiContentHeader,
  name: 'OrphanAccountOptions',
  slot: 'ContentHeader',
  styles: {
    textAlign: 'center',
    marginBottom: 0,
  },
});

export const GridContainer = superstyled({
  tag: Grid,
  name: 'OrphanAccountOptions',
  slot: 'GridContainer',
  propsAdded: {
    alignItems: 'center',
    container: true,
    direction: 'column',
    justifyContent: 'flex-start',
    margin: 0,
    gap: 4,
    width: '100%',
    marginTop: { xs: 4, md: 8 },
  },
});

export const CardsContainer = superstyled({
  tag: Grid,
  name: 'OrphanAccountOptions',
  slot: 'CardsContainer',
  propsAdded: {
    container: true,
    spacing: 3,
    justifyContent: 'center',
    sx: {
      width: '100%',
    },
  },
});

export const OptionCard = superstyled({
  tag: Grid,
  name: 'OrphanAccountOptions',
  slot: 'OptionCard',
  propsAdded: {
    item: true,
    xs: 12,
    sm: 8,
    md: 4,
  },
});

export const CardTitle = superstyled({
  tag: Heading,
  name: 'OrphanAccountOptions',
  slot: 'CardTitle',
  propsAdded: {
    size: 'xl',
    weight: 'medium',
    component: 'h3',
    sx: { mb: 1 },
  },
});

export const OptionCardInner = superstyled({
  tag: Card,
  name: 'OrphanAccountOptions',
  slot: 'OptionCardInner',
  styles: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const OptionCardContent = superstyled({
  tag: CardContent,
  name: 'OrphanAccountOptions',
  slot: 'OptionCardContent',
  styles: ({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(3),
  }),
});

export const CardDescription = superstyled({
  tag: Text,
  name: 'OrphanAccountOptions',
  slot: 'CardDescription',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2),
    flex: 1,
  }),
});

export const gradientButtonStyles = () => ({
  border: '1px solid transparent',
  transition: 'all 0.2s ease-in-out',
  background:
    'linear-gradient(#fff, #fff) padding-box, linear-gradient(249deg, #3971E7 27.22%, #33F28B 100%) border-box',
});
